import React, { useState, useEffect } from 'react'
import axios from 'axios';

import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/PopupDatasheet.css'
import './new_pages.css'


function KnittingmachinetypeNew({ 
  closeNewPopup, 
  fields, 
  sortedManufacturerOptions, 
  sortedDepartmentOptions,
  sortedInstitutionOptions,
  sortedLengthUnitOptions, 
  sortedDistanceUnitOptions, 
  formatTimestampNow, 
  sortedDatasheetOptions, 
  sortedPictureOptions, 
  fetchMachinetypes, 
  fetchMachinetypeDatasheetOptions,
  fetchMachinetypeImageOptions,
  fetchDepartmentOptions, 
  updateCurrentInstitutionName,
  copiedData, 
  newSaveID,
  setDefaultForEmptyNumberFields,
  convertCommaToDotForFloatFields, 
  handleFocus, 
  handleBlur, 
  validateField, 
  setErrors, 
  errors, 
  setErrorMessage,
  setShowErrorModal,
  handleDatasheetChangeAndUpload,
  handlePictureChangeAndUpload
}) {

  const access_token = window.localStorage.getItem('access_token');

  const id_institution = window.localStorage.getItem('id_institution');
  const id_role = window.localStorage.getItem('id_role');

  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState ({
    id_machinetype: '',
    machinetype_name: '',
    manufacturer_name: '',
    institution_name: '',
    department_name: '',
    fineness: '',
    needletype: '',
    max_workingwidth: '',
    unit_max_workingwidth_name: '',
    max_yarncarrier: '',
    knittingsystems: '',
    pulloff_system: '',
    clampingcutting_device: '',
    distance_needlebeds: '',
    unit_distance_needlebeds_name: '',
    datasheet: '',
    filename: '',
    machinetype_others: '',
    machinetype_all_can_read: false, // checkbox mit boolean-Wert initialisieren
    timestamp: '',        
  })
  

  useEffect(() => {
    // Wenn kopierter Datensatz vorhanden ist, setze ihn in den Zustand
    if (copiedData) {
      setPost(copiedData);
    }
    }, [copiedData]); // ueberwacht Aenderungen an kopierten Daten


  // useEffect wird ausgefuehrt, wenn der institution_name im dropdown geaendert wird
  useEffect(() => {
    if (post.institution_name) {
      fetchDepartmentOptions(post.institution_name); // Funktion zur Ausgabe der Bereiche für ausgewaehlte Institution
      fetchMachinetypeDatasheetOptions(post.institution_name); 
      fetchMachinetypeImageOptions(post.institution_name); 
      updateCurrentInstitutionName(post.institution_name);
    }
  }, [post.institution_name]);


  const handleInput = (event) => {
    const { name, type, value, checked } = event.target;

    // Pruefen, ob es sich um eine Checkbox handelt, um den `checked`-Wert statt `value` zu verwenden
    setPost(prevPost => ({
      ...prevPost,
      [name]: type === 'checkbox' ? checked : value, // Verwende `checked` für Checkboxen, `value` für andere
    }));

    // Entferne die Fehlermeldung, falls eine gueltige Auswahl getroffen wurde
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: null,
      }));
    }
  };


  // Funktion zum Speichern eines neuen Maschinentpys mit aktuellem Zeitstempel
  const handleNewSave = async () => {
    try {
      let newErrors = {};

      try {
        // Schritt 1: Alle Felder auf Leerwert pruefen und Fehler sammeln
        fields.forEach((field) => {
          const value = String(post[field.name] || ''); // Standardwert auf leer setzen, falls undefined
          const rules = field.validate || {};
          
          // Validierung aufrufen und Fehler im neuen Fehlerobjekt speichern
          const error = validateField(field.name, value, rules, (errorObj) => {
            newErrors = { ...newErrors, ...errorObj };
          });
          
          if (error) {
            newErrors[field.name] = error;
          }
        });
  
        // Schritt 2: Fehler im Zustand speichern
        setErrors(newErrors);
  
        // Schritt 3: Ueberpruefen, ob Fehler vorhanden sind
        const hasErrors = Object.values(newErrors).some((error) => error !== '');
  
        if (hasErrors) {
          // Zeige das Modal, wenn noch Fehler vorhanden sind
          setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
          setShowErrorModal(true);
          return; // Stoppe das Speichern, bis die Fehler behoben sind
        }

        // Fehler zuruecksetzen, falls alles korrekt ist
        setErrors({});

        const timestamp = formatTimestampNow(); // Aktuellen Zeitstempel abrufen und formatieren
        const newPost = { ...post, id_institution, timestamp }; // Zeitstempel zum neuen Eintrag hinzufügen

        // Setze leere Float- und Integer-Felder auf -123
        setDefaultForEmptyNumberFields(newPost, fields);
        // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
        convertCommaToDotForFloatFields(newPost, fields);

        const response = await axios.post(`${url_root}/new_knit_machinetype`, newPost,
            {
              headers: {
                  'Authorization': `Bearer ${access_token}`
              }
            }
        );

        // Ueberpruefen des Statuscodes in der API-Antwort
        const statusCode = response.status;
        if (statusCode === 232) {
          setErrorMessage("Dieser Name für Maschinentyp ist schon vergeben.");
          setShowErrorModal(true);
          return; // Stoppe das Speichern, bis ein neuer Name eingegeben ist
        } else if (statusCode === 231) {
          setErrorMessage("Bitte geben Sie eine Bezeichnung ein.");
          setShowErrorModal(true);
          return;
        }

        const id_machinetype = response.data.id_machinetype;
        fetchMachinetypes(); // Tabelle aktualisieren
        newSaveID(id_machinetype); // ID weitergeben, um den neuen Datensatz zu markieren
        closeNewPopup(); // Popup schließen
      } catch (error) {
        console.error('Fehler beim Speichern des neuen Eintrags:', error);
      }
    } catch (error) {
      console.error('Fehler beim Speichern des neuen Eintrags:', error);
    }
  };
  


  return (   
    <div className='new-popup-page'>
      <div className='new-title'>
        <h3>Hier können Sie einen neuen Maschinentyp anlegen:</h3>
      </div>

      {id_role == 1 && (
        <div className="new-input-row">
          <label>Institution</label>
          <div className="new-input-with-unit">

            {/* bei Aenderung der Institution werden nur die Bereiche dieser Institution angezeigt */}
            <select 
              onChange={(e) => {
                // hier wird der ausgewaehlte institution_name des Dropdown-Menues in Variable gespeichert
                const selectedInstitution = e.target.value; 
                // ...prevPost - alle anderen Daten im post-Objekt bleiben erhalten
                // und nur institution_name wird neu gesetzt
                setPost(prevPost => ({
                  ...prevPost,  
                  // institution_name wird geaendert, useEffect dadurch ausgeloest (Aufruf: fetchDepartmentOptions) 
                  institution_name: selectedInstitution, 
                  // Setzt Felder zurueck, damit die alte Auswahl im Dropdown raus ist
                  department_name: '',
                  datasheet: '',
                  filename: ''  
                }));
              }} 
              name="institution_name" 
              value={post.institution_name}
              onFocus={(event) => handleFocus(event, setErrors)}
              // Manuelle Validierung für institution_name aufrufen
              onBlur={(e) => {const value = e.target.value;
                // Wenn das Feld leer ist, setze eine Fehlermeldung
                if (!value) {
                  setErrors(prevErrors => ({
                    ...prevErrors,
                    institution_name: "Bitte wählen Sie eine Institution."
                  }));
                } else {
                  // Entferne den Fehler, wenn eine Institution ausgewaehlt ist
                  setErrors(prevErrors => ({
                    ...prevErrors,
                    institution_name: ''
                }));
              }
            }}
            >
              <option value=""></option>
              {sortedInstitutionOptions.map((option, index) => (              
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
            {/* Fehlernachricht für institution_name anzeigen */}
            {errors.institution_name && (
              <span className="error-message">{errors.institution_name}</span>
            )}
          </div>
        </div>
      )}

      {fields.map(field => {
        const fieldValue = post[field.name];
        // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
        const displayValue = fieldValue < 0 ? '' : fieldValue;

        return (
        <div key={field.name} className="new-input-row">
          <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>

          <div className="new-input-with-unit">
          {field.type === 'select' ? (
            <>
            <select 
              onChange={handleInput} 
              name={field.name} 
              value={displayValue}
              onFocus={(event) => handleFocus(event, setErrors)}
              onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                validateField(name, value, rules, setErrors))}
            >
              <option value=""></option>
              {field.name === 'manufacturer_name' && sortedManufacturerOptions.length > 0 ? (
                sortedManufacturerOptions.map((option, index) => (              
                  <option key={index} value={option}>
                    {option}
                  </option>
              ))
              ) : field.name === 'department_name' ? (
                sortedDepartmentOptions.length > 0 && sortedDepartmentOptions
                  .map((option, index) => (              
                    <option key={index} value={option}>
                      {option}
                    </option>               
              ))
              ) : field.name === 'datasheet' ? (
                sortedDatasheetOptions.length > 0 && sortedDatasheetOptions
                  .filter(option => option !== "") // Filtere leere Optionen heraus
                  .map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
              ))
              ) : field.name === 'filename' ? (
                sortedPictureOptions.length > 0 && sortedPictureOptions
                  .filter(option => option !== "") 
                  .map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
              ))
              ) : null}
            </select>
              {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
              {errors[field.name] && (
                <span className="error-message">{errors[field.name]}</span>
              )}
            </>
            ) : field.type === 'checkbox' ? (
              <div className="new-input-row-checkbox">
                <input
                  type="checkbox"
                  name={field.name}
                  checked={post[field.name]}
                  onChange={handleInput}
                />
              </div>
            ) : field.type === 'picture_button_group' ? ( 
              <div className='button-group'>
                <input
                  type="file"
                  id="fileInput8"
                  style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                  onChange={handlePictureChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                />
                <button
                  type="button"
                  className="custom-button"
                  onClick={() => document.getElementById('fileInput8').click()} // Öffnet den Datei-Dialog
                >
                  Bild auswählen und hochladen
                </button>
              </div>

            ) : field.type === 'datasheet_button_group' ? (
              <div className='button_group'>
                <input
                  type="file"
                  id="fileInput7"
                  style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                  onChange={handleDatasheetChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                />
                <button
                  type="button"
                  className="custom-button"
                  onClick={() => document.getElementById('fileInput7').click()} // oeffnet den Datei-Dialog
                >
                  Datenblatt auswählen und hochladen
                </button>
              </div>
            ) : field.type === 'textarea' ? (
              <textarea className='textarea'
                name={field.name}
                value={displayValue}
                onChange={handleInput}
              />
            ) : (
              <>
                <input
                  type={field.type}
                  name={field.name}
                  value={displayValue}
                  onChange={handleInput}

                  onFocus={(event) => handleFocus(event, setErrors)}
                  onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                    validateField(name, value, rules, setErrors))}    
                />
                {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}

                {field.unit && (                  
                  <div>
                    <select
                      className="new-unit-dropdown"
                      name={field.unit}
                      value={post[field.unit]}
                      onChange={handleInput}
                    >
                      <option value="" disabled> </option>
                      
                      {field.unit === 'unit_max_workingwidth_name' && sortedLengthUnitOptions.length > 0 ? (
                        sortedLengthUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))
                      ) : field.unit === 'unit_distance_needlebeds_name' && sortedDistanceUnitOptions.length > 0 ? (
                        sortedDistanceUnitOptions.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))
                      ) : null}
                    </select>                    
                   
                    {field.unit === 'unit_max_workingwidth_name' && errors.unit_max_workingwidth_name && (
                      <span className="error-message">{errors.unit_max_workingwidth_name}</span>)}
                    {field.unit === 'unit_distance_needlebeds_name' && errors.unit_distance_needlebeds_name && (
                      <span className="error-message">{errors.unit_distance_needlebeds_name}</span>)}
                    
                  </div>                                    
                  )}
                </>
              )}
            </div>
          </div>
          );
        })}

        <div className='new-input-save-cancel'>
          <button onClick={() => closeNewPopup()}>ABBRECHEN</button> 
          <button onClick={() => handleNewSave()}>SPEICHERN</button>       
        </div>   

    </div>    
  )
}

export default KnittingmachinetypeNew
